import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import { userAtom } from '../../store/atoms';
import NotificationDropdown from '../NotificationDropdown/NotificationDropdown';
import styles from './UserSection.module.scss';

interface UserSectionProps {
  isMobile: boolean;
  onMobileDrawerClose?: () => void;
}

const UserSection: React.FC<UserSectionProps> = ({
  isMobile,
  onMobileDrawerClose
}) => {
  const [user] = useAtom(userAtom);
  const navigate = useNavigate();

  if (!user) {
    return (
      <Button onClick={() => navigate('/login')} size={isMobile ? "small" : "middle"}>
        {!isMobile && "Login"}
      </Button>
    );
  }

  return (
    <>
      <span className={styles.userName}>
        {user?.firstName ? user.firstName : ''} {user?.lastName ? user.lastName : ''}
      </span>
      
      <NotificationDropdown 
        isMobile={isMobile}
        onMobileDrawerClose={onMobileDrawerClose}
      />
    </>
  );
};

export default UserSection; 